import {
  postCareOrderSidebarStats,
  type CareOrderSidebarStats,
} from '@/api/CareOrderSidebarStats'
import type { CareSidebarCounts } from '@/api/hmCareOrderTypes'

export type CareSidebarBadgeRefreshResult = {
  hmCareOrdersTotal: number
  sidebarCounts: CareSidebarCounts
}

/** 通过 POST care-order/sidebar-stats 刷新侧栏 HM 总数与四子目录角标 */
export async function refreshCareSidebarBadges(): Promise<CareSidebarBadgeRefreshResult> {
  const stats: CareOrderSidebarStats = await postCareOrderSidebarStats()
  return {
    hmCareOrdersTotal: stats.hmCareOrdersTotal,
    sidebarCounts: {
      pendingSchedule: stats.pendingSchedule,
      pendingReschedule: stats.pendingReschedule,
      fuPendingSchedule: stats.fuPendingSchedule,
      fuPendingReschedule: stats.fuPendingReschedule,
    },
  }
}
